import { ConsentBannerVisibilityPort } from '../../ports'

export class ShowConsentBannerUseCase {
  constructor(
    private readonly visibilityPort: ConsentBannerVisibilityPort,
    private readonly isApps: boolean
  ) {}

  hideInitial() {
    this.visibilityPort.hideConsentBanner()
  }

  run(): boolean {
    if (this.isApps) {
      return false
    }
    return this.initForWeb()
  }

  private initForWeb() {
    if (this.visibilityPort.shouldShowConsentBanner()) {
      this.visibilityPort.showConsentBanner()
      return true
    }
    return false
  }
}
